export default {
      id: "profil-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "img/icons.svg#profil",
      toString: function () {
        return this.url;
      }
    }